/* @flow */

// The Deferred returned by $.ajax satisfies this interface. You can also use
// createPromiseWithAbort to make one of these from a normal Promise and an
// abort function.
export type PromiseWithAbort<T> = {
  then: $PropertyType<Promise<T>, "then">,
  catch: $PropertyType<Promise<T>, "catch">,
  abort: () => void,
};

// eslint-disable-next-line import/prefer-default-export
export function createPromiseWithAbort<T>(
  promise: Promise<T>,
  abort: () => void
): PromiseWithAbort<T> {
  // $FlowFixMe: Flow's internal Promise type doesn't know about then.bind and catch.bind
  return {
    then: promise.then.bind(promise),
    catch: promise.catch.bind(promise),
    abort,
  };
}



// WEBPACK FOOTER //
// ./src/PromiseWithAbort.js